import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'
import { vn } from 'vend-number'
import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { BigCommergeGiftCertsOption } from '../PaymentModal/types'
import { usePaymentAmountForCashDiscounting } from './useGetPaymentAmountForCashDiscounting'

export const useHandleBigCommercePayment = (amountTendered: string) => {
  const {
    getPaymentAmountForCashDiscounting,
  } = usePaymentAmountForCashDiscounting()
  const t = useT()
  const handleBigCommercePayment = useCallback(
    (
      paymentType: ApiRetailerPaymentType
    ): BigCommergeGiftCertsOption | undefined => {
      if (!amountTendered || isNaN(Number(amountTendered))) {
        return
      }
      /**
       * Using cash discounting amount for payment will result in multiple payments to complete a sale even when gift card has enough funds
       * Better to use amount tendered as amount to pay instead
       * But it is existing behaviour in angularjs payment so I leave it as is
       */
      const amountToPay = getPaymentAmountForCashDiscounting(amountTendered)
      if (vn(amountToPay).lte(0)) {
        ToastNotifications.negative(
          t('Please enter a positive amount.', {
            _context: 'Gift card payment cannot be negative or 0',
          })
        )
        return
      }

      return {
        paymentType,
        amount: amountToPay!,
        paymentModalType: 'bigcommerceGiftCerts',
      }
    },
    [amountTendered, getPaymentAmountForCashDiscounting, t]
  )
  return {
    handleBigCommercePayment,
  }
}
